import { render } from "./AssistantResizeHandles.vue?vue&type=template&id=4554bc78&scoped=true"
import script from "./AssistantResizeHandles.vue?vue&type=script&lang=js"
export * from "./AssistantResizeHandles.vue?vue&type=script&lang=js"

import "./AssistantResizeHandles.vue?vue&type=style&index=0&id=4554bc78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4554bc78"]])

export default __exports__